import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef, ReactNode } from 'react';
import { Icon, IconName } from '../../foundations';
import styles from './IconLinkButton.module.css';
import { clsx } from 'clsx';

export type IconLinkButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
	/**
	 * Icon identifier from the Iberia Icons
	 * @default mas
	 */
	icon?: IconName;
	/**
	 * Text or children for the button or link
	 */
	children: ReactNode;
	/**
	 * If false (by default), it will be a span. If true, it will be a button component.
	 * @default true
	 */
	button?: boolean;
	/**
	 * Styles for the button
	 * @default mas
	 */
	className?: string;
};

/**
 * My Iberia Button or Text component (Tou use as SPA Link) with the color specific and icon. Defaults to button, depends on button prop.
 */
export const IconLinkButton = forwardRef<HTMLButtonElement, IconLinkButtonProps>(function LikeButton(
	{ icon = 'mas', children, button = true, className, ...props },
	ref
) {
	const Component = button ? 'button' : 'span';

	return (
		<Component type={button ? 'button' : undefined} className={clsx(styles.container, className)} ref={ref} {...props}>
			<Icon name={icon} className={styles.icon} />
			{children}
		</Component>
	);
});
